import { Organization } from "./organization";
import { User } from "./user";
import { Location } from "./location";
import { PickupEstimatedItem } from "./pickupEstimatedItem";
import { PickupContact } from "./pickupContact";
import { ActiveStorageAttachment } from "./activeStorageAttachment";
import { PickupAgent } from "./pickupAgent";
import { Agent } from "./agent";

export const PickupStatuses = [
  { label: "Draft", value: "draft" },
  { label: "Missing Info", value: "missing_info" },
  { label: "Pending Confirmation", value: "pending_confirmation" },
  { label: "Scheduled", value: "scheduled" },
  { label: "Reschedule Pending", value: "reschedule_pending" },
  { label: "Processing", value: "processing" },
  { label: "Initial Report Ready", value: "initial_report_ready" },
  { label: "On Hold", value: "on_hold" },
  { label: "Verifying", value: "verifying" },
  { label: "Canceled", value: "canceled" },
  { label: "Complete", value: "complete" },
  { label: "Archived", value: "archived" },
] as const;

export type PickupStatusOptions = (typeof PickupStatuses)[number];
export type PickupStatus = PickupStatusOptions["value"];

export interface Pickup {
  id: number;
  uuid: string;
  scheduledAt: string;
  retiredAt?: string | null;
  state: string;
  softthinksMode: string;
  reason: string;
  devicesCentralizedLocation?: boolean;
  devicesAlreadyPalletized?: boolean;
  onSitePersonPresent?: boolean;
  officeClosureDate?: string | null;
  otherVendorsOnSite?: string | null;
  devicesLeftBehind?: string | null;
  ewasteInLbs: number | "";
  user: User;
  organization: Organization;
  location: Location;
  pickupEstimatedItems: PickupEstimatedItem[];
  pickupImages: ActiveStorageAttachment[];
  certificateOfInsuranceFile?: ActiveStorageAttachment | null;
  pickupContacts: PickupContact[];
  orderNumber: number;
  agent: Agent;
  subAgent: Agent;
  pickupAgent: PickupAgent;
  comments?: string;
  requestedTime?: string;
  confirmedTime?: string;
  cancellationReason?: string;
  canceledBy?: User;
  inventoryCount?: number;
  enrolledCount?: number;
  virtualPickup?: boolean;
  enrollmentV2?: boolean;
  assetRetrievalsToDate?: number;
}

export interface DrawerProps {
  pickup: Pickup;
}

export interface OnHoldDrawerProps {
  pickup: Pickup;
  markPickupUnenrolled: Function;
}

export interface MissingInfoDrawerProps {
  pickup: Pickup;
  deletePickup: Function;
}
